// extracted by mini-css-extract-plugin
export default {"share-button":"JH2Uq","share-button__snackbar":"BLU7h"};